/**
 * Window events that open viewer actions from OUTSIDE the viewer tree —
 * the TMS common header's Search / .evidence buttons dispatch them BY
 * LITERAL NAME (importing this package in host chrome would pull the
 * whole viewer into that chunk; the /evidence route lazy-loads it).
 * AppShell listens for both while a pack is open.
 */
export var EV_OPEN_PALETTE_EVENT = 'evidence-viewer:open-palette';
export var EV_DOWNLOAD_PACK_EVENT = 'evidence-viewer:download-pack';

/** Host-facing entry point: open the ⌘K palette of a mounted viewer. */
export function openEvidencePalette() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(EV_OPEN_PALETTE_EVENT));
  }
}

/** Host-facing entry point: download the open pack as a .evidence file. */
export function downloadEvidencePack() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(EV_DOWNLOAD_PACK_EVENT));
  }
}